import { Briefcase } from "lucide-react";

export function ContractorPortalEmptyState() {
  return (
    <div
      data-testid="contractor-portal-empty-state"
      className="rounded-xl border border-border bg-card p-6 text-center"
    >
      <div className="mx-auto mb-3 h-10 w-10 rounded-lg bg-muted flex items-center justify-center">
        <Briefcase className="h-5 w-5 text-muted-foreground" />
      </div>
      <p className="text-sm font-medium">You're all set</p>
      <p className="text-xs text-muted-foreground mt-1">
        Jobs will appear here once assigned.
      </p>
    </div>
  );
}
